// extracted by mini-css-extract-plugin
export default {"tableContainer":"MyProjectScoreCard_tableContainer__dQAT5"};